export default "__VITE_ASSET__CNX$2$MT__"